import { render, staticRenderFns } from "./RecommendNoteComponent.vue?vue&type=template&id=87a01ea6&scoped=true&"
import script from "./RecommendNoteComponent.vue?vue&type=script&lang=js&"
export * from "./RecommendNoteComponent.vue?vue&type=script&lang=js&"
import style0 from "./RecommendNoteComponent.vue?vue&type=style&index=0&id=87a01ea6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a01ea6",
  null
  
)

export default component.exports